import React, { useEffect, useRef, useState } from 'react';
import styles from './CareerSection.module.css';

// Ensure these paths are 100% correct in your local project
import teamHero from '../../assets/career.png';
import teamSmall from '../../assets/career.png';

const CareerSection = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  const benefits = [
    "Competitive Earnings & Performance Incentives",
    "Career Progression & Skill Development",
    "Exclusive Access & Industry Networking"
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className={`${styles.wrapper} ${visible ? styles.show : ""}`}>
      {/* 1. Full-Width Hero */}
      <div className={styles.heroContainer}>
        <img 
          src={teamHero} 
          alt="Our Team" 
          className={styles.heroImg} 
          onError={(e) => console.error("Hero image failed to load:", e.target.src)}
        />
      </div>

      {/* 2. Content Section */}
      <div className={styles.contentSection}>
        <div className={styles.container}>
          <div className={styles.grid}>
            
            {/* Left Content */}
            <div className={styles.textSide}>
              <h2 className={styles.title}>
                YOU WILL LOVE <br /> WORKING HERE
              </h2>
              <p className={styles.description}>
                Working here means being at the center of the action where 
                creativity, precision, and energy collide every night. From front-of-house 
                to production and management, every role contributes to shaping 
                memorable experiences.
              </p>
              
              <ul className={styles.benefitsList}>
                {benefits.map((benefit, index) => (
                  <li 
                    key={index} 
                    className={styles.benefitItem}
                    style={{ transitionDelay: `${(index + 2) * 150}ms` }}
                  >
                    <span className={styles.dot}>•</span> {benefit}
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Side Image */}
            <div className={styles.imageSide}>
              <div className={styles.sideImageWrapper}>
                <img 
                  src={teamSmall} 
                  alt="Kitchen Team" 
                  onError={(e) => console.error("Side image failed to load:", e.target.src)}
                />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerSection;